import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Elevation, { ElevationProps } from 'components/Elevation';
import Styled from './styles';

const ELEVATION_INDEX = 8;
const ELEVATION_DARK = false;

export interface MultiSelectSmartListProps extends React.ComponentPropsWithRef<'div'> {
  /** To render the header and list, consider using 'MultiSelectSmartListHeader', 'MultiSelectSmartCheckboxList'. */
  children: React.ReactNode;
  /** Override the Elevation properties. See Elevation component for details. */
  elevationProps?: Partial<ElevationProps>;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Component for displaying a header and vertical list of items with checkboxes.
 * Any other props than 'MultiSelectSmartList' props will be provided to the root element
*/
const MultiSelectSmartList = React.forwardRef<HTMLElement, MultiSelectSmartListProps>((props: MultiSelectSmartListProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    elevationProps,
    theme: propTheme,
    ...otherProps
  } = props;
  const userTheme = propTheme.LIST && propTheme.LIST.VERTICAL;
  const resolvedTheme = _merge({}, theme.LIST.VERTICAL, userTheme);
  return (
    <Elevation
      elevationIndex={ELEVATION_INDEX}
      dark={ELEVATION_DARK}
      {...elevationProps}
    >
      <Styled.MultiSelectSmartListWrapper
        ref={ref}
        tabIndex={-1}
        RTL={RTL}
        $theme={resolvedTheme}
        {...otherProps}
      >
        {children}
      </Styled.MultiSelectSmartListWrapper>
    </Elevation>
  );
}));

MultiSelectSmartList.displayName = 'MultiSelectSmartList';

MultiSelectSmartList.defaultProps = {
  elevationProps: {
    elevationIndex: 8,
    dark: false,
  },
  theme: {},
};

export default MultiSelectSmartList;
